import {useCallback} from "react";
import {useAppContext} from "@/context/app";
import useAuth from "@/hooks/useAuth.ts";
type UseLoadDataHook = {
    loadData: () => Promise<void>,
}
const useLoadData = (): UseLoadDataHook => {

    const {loaded, setLoaded, auth} = useAppContext()
    const {loadRoles} = useAuth()

    const token = auth.user?.token

    const loadData = useCallback((): Promise<void> => {
            return new Promise((resolve, reject)=>{
                if (token && !loaded) {
                    const roles = loadRoles()
                    Promise.all([roles]).then(() => {
                        setLoaded(true)
                        resolve()
                    }).catch((err) => reject(err))
                }
            })

    }, [token, loaded])

    return {
        loadData
    };
};

export default useLoadData;